<template>
  <common-action-log
    :actionLog="actionLog"
    :actionNameLabel="actionNameLabel"
    :iconClass="['font-size__small', 'fal fa-check-circle', 'color__blue']"
  >
  </common-action-log>
</template>

<script>
import convertToLabelFilter from "../../../filters/convertToLabelFilter";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import ActionLogTemplate from "./action-log-template";
import CommonActionLog from "./common-action-log";

export default {
  name: "hc-commands-common-create-action-log",
  components: {CommonActionLog, ActionLogTemplate},
  props: ["actionLog"],
  filters: {
    convertToLabelFilter
  },
  data() {
    return {
      actionNameLabel: null
    };
  },
  created() {
    this.actionNameLabel = hanhChinhUtils.getActionLogActionNameLabel(
      this.actionLog.actionName
    );
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/hc-commands-common-create-action-log.vue